module.exports = __webpack_public_path__ + "img/tianchengmoliyanwobing.9dd46705.jpg";